export default {
    searchList: {
        fieldTrim: true,
        searchTxt: [
            {
                name: '批量选择',
                value: 'batchQueryValue',
                type: 'input',
                placeholder: '支持批量查询，英文逗号或空格分开',
                selectConfig: {
                    width: '85px',
                    prop: 'batchQueryKey',
                    value: 'customerOrderNoList',
                    option: [
                        { label: '客户订单号', prop: 'customerOrderNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '运输单号', prop: 'taskNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '京东VC号', prop: 'jdVcList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '上游集拼单号', prop: 'consolidationOrderNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '事业部集拼号', prop: 'assembleNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '计划单号', prop: 'planOrderNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '波次号', prop: 'waveIdList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '物流单号', prop: 'orderNoList', placeholder: '支持批量查询，英文逗号或空格分开' }
                    ]
                },
                unfold: true,
                span: 5
            },
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                placeholder: '发车单号(支持批量查询，英文逗号或空格分开)',
                unfold: true,
                span: 3
            },
            {
                name: '运单状态',
                value: 'taskStatusList',
                // filterable: true,
                type: 'select',
                multiple: true, // 多选
                unfold: true,
                optionNum: 'TRANSPORT_STATUS',
                span: 3,
                options: []
            },
            {
                name: '任务类型',
                value: 'taskTypeList',
                type: 'select',
                // filterable: true,
                multiple: true, // 多选
                optionNum: 'TASK_TYPE',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '任务创建时间',
                value: 'createTime',
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间',
                type: 'time',
                unfold: true,
                timeNum: 2,
                span: 4
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        hasMaxBtnNum: true, // 开始更多操作按钮
        maxBtnNum: 2,
        selectBtn: true,
        fixedSeletionColumn: true,
        height: 400,
        leftWidth: 150,
        columns: [
            {
                label: '运单状态',
                prop: 'taskStatusName',
                type: 'button',
                width: '100px',
                sort: true
            },
            {
                label: '是否已下发承运商',
                prop: 'carrierVisibleFlagName',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: 'Y' },
                    { label: '否', value: 'N' }
                ],
                width: '100px',
                sort: true
            },
            {
                label: '是否分仓标识',
                prop: 'isAllocateWhName',
                width: '100px',
                sort: true
            },
            {
                label: '京东VC单号',
                prop: 'jdVcNo',
                width: '120px',
                sort: true
            },
            {
                label: '营销中心',
                prop: 'salesCenterName',
                width: 200
            },
            {
                label: '后分仓标识',
                prop: 'orderDistinctionFlag',
                width: '120px',
                sort: true
            },
            {
                label: '仓库代码',
                prop: 'whCode',
                width: '100px',
                sort: true
            },
            {
                label: '仓网融合平台',
                prop: 'fuseSiteName',
                width: '100px',
                sort: true
            },
            {
                label: '预计到达开始时间',
                prop: 'expectArriveStartTime',
                width: '150px',
                sort: true
            },
            {
                label: '订单创建时间',
                prop: 'orderTime',
                width: '150px',
                sort: true
            },
            {
                label: '上游下单时间',
                prop: 'upperOrderTime',
                width: '150px',
                sort: true
            },
            {
                label: '移交单号',
                prop: 'transferNo',
                width: '180px',
                sort: true
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                width: '180px',
                sort: true
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                width: '200px'
            },
            {
                label: '是否需要扫码',
                prop: 'scanFlag',
                type: 'select',
                optionNum: 'SCAN_FLAG',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '高端服务',
                prop: 'orderTypeExt',
                type: 'select',
                optionNum: 'OTP_EMERGENCE_FLAG',
                options: [],
                sort: true,
                width: 140
            },
            {
                label: '计划单号',
                prop: 'planOrderNo',
                width: '150px',
                sort: true
            },
            {
                label: '平台单号',
                prop: 'platformOrderNo',
                width: '160px',
                sort: true
            },
            {
                label: '计划数量',
                prop: 'totalQty',
                width: '200px',
                sort: true
            },
            {
                label: '下发人',
                prop: 'issueCarrierMip',
                width: '150px'
            },
            {
                label: '计划重量(kg)',
                prop: 'totalGrossWeight',
                width: '150px'
            },
            {
                label: '计划体积(m³)',
                prop: 'totalVolume',
                width: '150px'
            },
            {
                label: '备注',
                prop: 'remark',
                width: '200px'
            },
            {
                label: '发运类型',
                prop: 'shippingTypeName',
                sort: true,
                width: 120
            },
            {
                label: '班次编码',
                prop: 'shiftCode',
                sort: true,
                width: 120
            },
            {
                label: '班次截单时间',
                prop: 'shiftOrderEndTime',
                sort: true,
                width: 180
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '180px',
                sort: true
            },
            {
                label: '任务创建时间',
                prop: 'createTime',
                width: '180px',
                sort: true
            },
            {
                label: '转单类型',
                prop: 'transferType',
                width: '100px',
                type: 'select',
                optionNum: 'TRANSFER_TYPE_TMS',
                options: [],
                sort: true
            },
            {
                label: '任务类型',
                prop: 'taskTypeName',
                width: '120px',
                sort: true
            },
            {
                label: '出入库类型',
                prop: 'inOutTypeName',
                width: '120px',
                sort: true
            },
            {
                label: '工号',
                prop: 'workOrderNo',
                sort: true,
                width: 160
            },
            {
                label: '要求提货开始时间	',
                prop: 'expectPickStartTime',
                sort: true,
                width: 160
            },
            {
                label: '要求提货结束时间',
                prop: 'expectPickEndTime',
                sort: true,
                width: 160
            },
            {
                label: '分公司名称',
                prop: 'companyName',
                width: '120px',
                sort: true
            },
            {
                label: '分公司编码',
                prop: 'companyCode',
                width: '120px',
                sort: true
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                width: '200px',
                sort: true
            },
            {
                label: '运单号',
                prop: 'waybillNo',
                width: '200px',
                sort: true
            },
            {
                label: '订单类型',
                prop: 'orderTypeName',
                width: '120px',
                sort: true
            },
            {
                label: '客户名称',
                prop: 'customerName',
                width: '180px',
                sort: true
            },
            {
                label: '客户编码',
                prop: 'customerCode',
                width: '120px',
                sort: true
            },
            {
                label: '订单来源平台',
                prop: 'orderSourcePlatformName',
                width: '148px',
                sort: true
            },
            {
                label: '来源系统',
                prop: 'sourceSystemName',
                width: '148px',
                sort: true
            },
            {
                label: '业务模式',
                prop: 'businessModeName',
                width: '80px',
                sort: true
            },
            {
                label: '项目分类',
                prop: 'projectClassifyName',
                sort: true,
                width: 110
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: '110px',
                sort: true
            },
            {
                label: '供方预约',
                prop: 'supplierReserveFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'Y', label: '是' },
                    { value: 'N', label: '否' }
                ],
                width: '110px',
                sort: true
            },
            {
                label: '省内/省际',
                prop: 'interprovincial',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '省内' },
                    { value: '2', label: '省际' }
                ],
                width: '110px',
                sort: true
            },
            {
                label: '是否供应商转快递',
                prop: 'supplierKdFlag',
                type: 'select',
                optionNum: 'SUPPLIER_KD_FLAG',
                options: [],
                width: '160px',
                sort: true
            },
            {
                label: '仓库',
                prop: 'whName',
                width: '148px',
                sort: true
            },
            {
                label: '线路里程',
                prop: 'mileage',
                width: '148px',
                sort: true
            },
            {
                label: '是否模糊订单',
                prop: 'planOrderFlagName',
                width: '148px',
                sort: true
            },
            {
                label: '原承运商',
                prop: 'planCarrierName',
                width: '160px',
                sort: true
            },
            {
                label: '线路名称',
                prop: 'lineName',
                width: '200px',
                sort: true
            },
            {
                label: '线路名称(旧)',
                prop: 'lineNameV1',
                width: '200px',
                sort: true
            },
            {
                label: '源发车单号',
                prop: 'sourceDispatch',
                sort: true,
                width: '200px'
            },
            {
                label: '总包件数',
                prop: 'totalPkgQty',
                sort: true,
                width: 100
            },
            {
                label: '业务场景',
                prop: 'businessCategoryName',
                width: '120px',
                sort: true
            },
            {
                label: '销售员名称',
                prop: 'salesmanName',
                width: '120px',
                sort: true
            },
            {
                label: '运费类型',
                prop: 'deliverypayTypeName',
                sort: true,
                width: 110
            },
            {
                label: '订单服务类型',
                prop: 'serviceType',
                type: 'select',
                optionNum: 'ORDER_SERVICE_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '是否代收',
                prop: 'collectionFlagName',
                sort: true,
                width: 110
            },
            {
                label: '场景标识',
                prop: 'loanScenarioCode',
                type: 'select',
                optionNum: 'CUSTOMER_SCENCE',
                options: [],
                sort: true,
                width: 110
            },
            {
                label: 'WMS状态',
                prop: 'wmsStatusName',
                width: '120px',
                sort: true
            },
            {
                label: '运输里程(高德)(km)',
                prop: 'amapMileage',
                sort: true,
                width: 160
            },
            {
                label: '是否已扫码提货',
                prop: 'pickUpName',
                sort: true,
                width: 110
            },
            {
                label: '专业公司',
                prop: 'professionalCompanyName',
                sort: true,
                width: 130
            },
            {
                label: '是否提供装卸服务',
                prop: 'handlingStatusName',
                width: '160px',
                sort: true
            },
            {
                label: '装卸供应商',
                prop: 'handlingCarrierName',
                width: '160px',
                sort: true
            },
            {
                label: '是否分拨订单',
                prop: 'distributionFlagName',
                width: '80px',
                sort: true
            },
            {
                label: '是否最后一次分拨',
                prop: 'distributionLastFlagName',
                width: '80px',
                sort: true
            },
            {
                label: '实发数量',
                prop: 'qtyItemLoaded',
                width: '100px',
                sort: true
            },
            {
                label: '实扫数量',
                prop: 'rfActLoadQty',
                width: '100px',
                sort: true
            },
            {
                label: '配送方式',
                prop: 'deliveryTypeName',
                width: '80px',
                sort: true
            },
            {
                label: '库区名称',
                prop: 'zoneName',
                width: '80px',
                sort: true
            },
            {
                label: '目的地区',
                prop: 'finalDistrictName',
                width: '80px',
                sort: true
            },
            {
                label: '目的地省',
                prop: 'finalProvinceName',
                width: '100px',
                sort: true
            },
            {
                label: '目的地市',
                prop: 'finalCityName',
                width: '80px',
                sort: true
            },
            {
                label: '目的地乡镇',
                prop: 'finalTownName',
                width: '80px',
                sort: true
            },
            {
                label: '目的地详细地址',
                prop: 'finalDetailAddr',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 160
            },
            {
                label: '始发仓',
                prop: 'orderWhName',
                width: '80px',
                sort: true
            },
            {
                label: '仓库分组',
                prop: 'warehouseGroup',
                width: '148px',
                sort: true
            },
            {
                label: '合同号',
                prop: 'contractNo',
                width: '148px',
                sort: true
            },
            {
                label: '采购渠道',
                prop: 'procurementChannelName',
                width: '148px',
                sort: true
            },
            {
                label: '下发承运商时间',
                prop: 'carrierVisibleTime',
                width: '200px',
                sort: true
            },
            {
                label: '要求发货时间',
                prop: 'requireOutTime',
                width: '200px',
                sort: true
            },
            {
                label: '要求到车时间',
                prop: 'requireCarArriveTime',
                width: '200px',
                sort: true
            },
            {
                label: '预到车时间',
                prop: 'makeArriveTime',
                width: '200px',
                sort: true
            },
            {
                label: '要求发车时间',
                prop: 'requireDepartTime',
                width: '200px',
                sort: true
            },
            {
                label: '要求抵达时间',
                prop: 'requireArriveTime',
                width: '200px',
                sort: true
            },
            {
                label: '要求签收时间',
                prop: 'requestSignDate',
                width: '200px',
                sort: true
            },
            {
                label: '实际到车时间',
                prop: 'actualArriveDate',
                width: '200px',
                sort: true
            },
            {
                label: '实际发车时间',
                prop: 'actDepartTime',
                width: '200px',
                sort: true
            },
            {
                label: '实际抵达时间',
                prop: 'arrivalTime',
                width: '200px',
                sort: true
            },
            {
                label: '实际签收时间',
                prop: 'signTime',
                width: '200px',
                sort: true
            },
            {
                label: '签收类型',
                prop: 'deliveredVerifyFlagName',
                width: '120px'
            },
            {
                label: '是否可见',
                prop: 'carrierVisibleFlagName',
                width: '120px'
            },
            {
                label: '收货地省名称',
                prop: 'receiverProvinceName',
                width: '120px'
            },
            {
                label: '波次号',
                prop: 'waveId',
                width: '120px',
                sort: true
            },
            {
                label: '仓货标识',
                prop: 'warehouseIdentification',
                type: 'select',
                optionNum: 'WAREHOUSE_IDENTIFICATION',
                options: [],
                width: '160px',
                sort: true
            },
            {
                label: '线路类别',
                prop: 'orderLineType',
                type: 'select',
                optionNum: 'ORDER_LINE_TYPE',
                options: [],
                width: '160px',
                sort: true
            },
            {
                label: '收货地市名称',
                prop: 'receiverCityName',
                width: '120px'
            },
            {
                label: '发货人详细地址',
                prop: 'senderDetailAddr',
                type: 'desensitized', // 脱敏
                width: '120px'
            },
            {
                label: '发货地区县',
                prop: 'senderDistrictName',
                width: '120px'
            },
            {
                label: '发货地省',
                prop: 'senderProvinceName',
                width: '120px'
            },
            {
                label: '发货地市',
                prop: 'senderCityName',
                width: '120px'
            },
            {
                label: '发货地乡镇',
                prop: 'senderTownName',
                width: '120px'
            },
            {
                label: '分拨仓库',
                prop: 'distributionWhName',
                width: '120px'
            },
            {
                label: '承运商名称',
                prop: 'carrierName',
                width: '120px'
            },
            {
                label: '承运商编码',
                prop: 'carrierCode',
                width: '120px'
            },
            {
                label: '是否下发零担平台',
                prop: 'isIssueName',
                width: 110
            },
            {
                label: '打印次数',
                prop: 'printCount',
                sort: true,
                width: 160
            },
            {
                label: '零担订单号',
                prop: 'lqId',
                sort: true,
                width: 110
            },
            {
                label: '零担运单号',
                prop: 'lclNo',
                sort: true,
                width: 140
            },
            {
                label: '撤销原因',
                prop: 'cancelRemark',
                width: 110
            },
            {
                label: '平台车牌号',
                prop: 'lclVehicleCard',
                width: 110
            },
            {
                label: '平台发车时间',
                prop: 'lclDepartureTime',
                width: 160
            },
            {
                label: '事业部集拼单号',
                prop: 'assembleNo',
                width: 200
            },
            {
                label: '运输划分标识',
                prop: 'transportationDivisionName',
                width: 120
            },
            {
                label: '服务产品编码',
                prop: 'productCode',
                width: 160
            },
            {
                label: '服务产品名称',
                prop: 'productName',
                width: 160
            },
            {
                label: '实时位置跟踪',
                prop: 'lastTrackingLocation',
                sort: true,
                width: 180
            },
            {
                label: '最后跟踪时间',
                prop: 'lastTrackingDate',
                sort: true,
                width: 180
            },
            {
                label: '跟踪方式',
                prop: 'lastTrackingSource',
                type: 'select',
                optionNum: 'OTP_TRACKING_SOURCE',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '操作类型',
                prop: 'dispatchMethod',
                type: 'select',
                optionNum: 'TMS_DISPATCHTYPE_ROWCAR',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '实际车型',
                prop: 'equipmentName',
                sort: true,
                width: 180
            },
            {
                label: '标准收货人名称',
                prop: 'standardReceiverName',
                width: 160
            },
            {
                label: '事业部',
                prop: 'entityId',
                type: 'select',
                optionNum: 'OMS_PARAMS_ENTITY_ID',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '快递单号',
                prop: 'expressNo',
                sort: true,
                width: 160
            },
            {
                label: '装车完成时间',
                prop: 'ztbLoadDate',
                sort: true,
                width: 180
            },
            {
                label: '发车确认时间',
                prop: 'departConfirmDate',
                sort: true,
                width: 160
            },
            {
                label: '上游集拼单号',
                prop: 'consolidationOrderNo',
                sort: true,
                width: 180
            },
            {
                label: '到车方式',
                prop: 'arriveType',
                type: 'select',
                optionNum: 'PICK_UP_TYPE',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '发车方式',
                prop: 'dispatchWay',
                type: 'select',
                optionNum: 'DISPATCH_WAY',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '抵达方式',
                prop: 'arrivalWay',
                type: 'select',
                optionNum: 'ARRIVER_WAY',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '预约类型',
                prop: 'snAppointmentType',
                type: 'select',
                optionNum: 'APPOINTMENT_TYPE',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '包裹数',
                prop: 'sumPackages',
                sort: true,
                width: 160
            },
            {
                label: '是否基地',
                prop: 'orderDistinctionFlagName',
                sort: true,
                width: 160
            },
            {
                label: '到车人工操作原因',
                prop: 'arriveOperateReason',
                sort: true,
                width: 160
            },
            {
                label: '抵达人工操作原因',
                prop: 'arrivalOperateReason',
                sort: true,
                width: 160
            },
            {
                label: '围栏到车时间',
                prop: 'fenceArriveTime',
                sort: true,
                width: 160
            },
            {
                label: '围栏发车时间',
                prop: 'fenceDepartTime',
                sort: true,
                width: 160
            },
            {
                label: '围栏抵达时间',
                prop: 'fenceArrivalTime',
                sort: true,
                width: 160
            },
            {
                label: '收货单位名称',
                prop: 'upperReceiverName',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 160
            },
            {
                label: '收货人',
                prop: 'receiverName',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 160
            },
            {
                label: '收货人固定电话',
                prop: 'receiverMobile',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 160
            },
            {
                label: '收货人手机号码',
                prop: 'receiverTel',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 160
            },
            {
                label: '车牌号',
                prop: 'vehicleCard',
                sort: true,
                width: 160
            },
            {
                label: '出库时间',
                prop: 'loadDate',
                sort: true,
                width: 160
            },
            {
                label: '收货详细地址',
                prop: 'receiverDetailAddr',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 160
            },
            {
                label: '齐套号',
                prop: 'qtOrderNo',
                sort: true,
                width: 160
            },
            {
                label: '预约单号',
                prop: 'snAppointmentNo',
                sort: true,
                width: 160
            },
            {
                label: '网点编码',
                prop: 'networkCode',
                sort: true,
                width: 160
            },
            {
                label: '网点名称',
                prop: 'networkName',
                sort: true,
                width: 160
            },
            {
                label: '运输类型',
                prop: 'transportType',
                type: 'select',
                optionNum: 'TRANSPORT_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '司机',
                prop: 'driver',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 160
            },
            {
                label: '风险标识',
                prop: 'riskMarking',
                sort: true,
                width: 160
            },
            {
                label: '是否已提货',
                prop: 'pickUpStatus',
                type: 'select',
                optionNum: 'PICK_UP_STATUS',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '到车跟踪来源',
                prop: 'arriveTrackingSource',
                type: 'select',
                optionNum: 'TMS_TRACKING_SOURCE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '发车跟踪来源',
                prop: 'departTrackingSource',
                type: 'select',
                optionNum: 'TMS_TRACKING_SOURCE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '抵达跟踪来源',
                prop: 'arrivalTrackingSource',
                type: 'select',
                optionNum: 'TMS_TRACKING_SOURCE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '对接平台',
                prop: 'externalType',
                sort: true,
                width: 160
            },
            {
                label: '开票单位',
                prop: 'invoiceUnitName',
                sort: true,
                width: 160
            },
            {
                label: '预约模式',
                prop: 'bookingMode',
                type: 'select',
                optionNum: 'TMS_BOOKING_MODE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '预约时间',
                prop: 'appointmentTime',
                sort: true,
                width: 160
            },
            {
                label: '物流单号',
                prop: 'orderNo',
                width: 180,
                sort: true
            },
            {
                label: '实发方量(m³)',
                prop: 'loadedVolume',
                sort: true,
                width: 160
            },
            {
                label: '实发重量(kg)',
                prop: 'loadedGrossWeight',
                sort: true,
                width: 160
            },
            {
                label: '拆单源任务号',
                prop: 'originTaskNo',
                width: '140px',
                sort: true
            },
            {
                label: '拆单原因',
                prop: 'orderSplitReason',
                width: '140px',
                sort: true
            },
            {
                label: '拆单源总数量',
                prop: 'originTotalQty',
                width: '140px',
                sort: true
            },
            {
                label: '运单设备号',
                prop: 'deviceNo',
                sort: true,
                width: 160
            },
            {
                label: '运单设备类型',
                prop: 'deviceType',
                type: 'select',
                optionNum: 'DEVICETYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '发车单设备号',
                prop: 'dispatchDeviceNo',
                sort: true,
                width: 160
            },
            {
                label: '发车单设备类型',
                prop: 'dispatchDeviceType',
                type: 'select',
                optionNum: 'DEVICETYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '买方类型',
                prop: 'sourceBuyerTenantType',
                type: 'select',
                optionNum: 'OMS_BUYER_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: 'VP客户标识',
                prop: 'vipFlag',
                type: 'select',
                optionNum: 'TMS_VIP_FLAG',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '是否绑定设备号',
                prop: 'bindingDeviceFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '0', label: '已绑' },
                    { value: '1', label: '未绑' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '设备号绑定时间',
                prop: 'deviceNoBoundTime',
                sort: true,
                width: 160
            },
            {
                label: '设备号解绑时间',
                prop: 'deviceNoUnboundTime',
                sort: true,
                width: 160
            },
            {
                label: '2C批量直配',
                prop: 'b2cZpFlag',
                type: 'select',
                options: [
                    { label: '是', value: '1' },
                    { label: '否', value: '0' }
                ],
                sort: true,
                width: 110
            },
            {
                label: '是否继续分拨',
                prop: 'continueDistribution',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'Y', label: '是' },
                    { value: 'N', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '是否直控线路',
                prop: 'directControlFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '是' },
                    { value: '0', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '计费业务类型',
                prop: 'businessType',
                type: 'select',
                optionNum: 'BUSINESS_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '收入计费前置',
                prop: 'billingIncomeAdvanceFlag',
                type: 'select',
                optionNum: 'BILLING_ADVANCE_FLAG',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '成本计费前置',
                prop: 'billingCostAdvanceFlag',
                type: 'select',
                optionNum: 'BILLING_ADVANCE_FLAG',
                options: [],
                sort: true,
                width: 160
            }
        ],
        action: [
            {
                type: 'text',
                label: '打印日志',
                size: 'small',
                event: 'printLog',
                ifHas: ''
            }
            // {
            //     type: 'text',
            //     label: '查看轨迹',
            //     size: 'small',
            //     event: 'viewTrack',
            //     ifHas: '150201003'
            // }
        ],
        leftOperation: true
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 100,
        pageSizes: [10, 20, 30, 50, 100]
    },
    searchTotalTitle: [
        {
            name: '项目分类',
            value: 'projectClassifyList',
            type: 'select',
            filterable: true,
            multiple: true, // 多选
            optionNum: 'PROJECT_CLASSIFY',
            options: []
        },
        {
            name: '是否下发零担平台',
            value: 'isIssue',
            type: 'select',
            optionNum: 'IS_ISSUE',
            options: []
        },
        {
            name: 'WMS状态',
            value: 'wmsStatusList',
            multiple: true,
            type: 'select',
            optionNum: 'WMS_STATUS',
            options: []
        },
        {
            name: '买方类型',
            value: 'sourceBuyerTenantTypeList',
            multiple: true,
            type: 'select',
            optionNum: 'OMS_BUYER_TYPE',
            options: []
        },
        {
            name: '车牌号',
            advanceLabel: '车牌号',
            value: 'vehicleCard',
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'licensePlateNumber', value: '车牌'
            },
            advanceConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolumeStr', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            tableConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolume', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            advanceUrl: 'suCar/searchByConditions',
            type: 'advance',
            cbParams: ['licensePlateNumber#vehicleCard', 'cargoVolumeStr', 'cdegNameCn#equipmentName', 'suppliersCode', 'cdegNameCn#equipmentType'],
            advanceCascade: 'carrierCode#suppliersCode'
        },
        {
            name: '司机',
            type: 'advance',
            value: 'driver',
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'name', value: '司机名称'
            },
            advanceConfig: [
                { prop: 'name', value: '司机名称' },
                { prop: 'encuMobile', value: '司机电话' }
            ],
            tableConfig: [
                { prop: 'name', value: '司机名称' },
                { prop: 'encuMobile', value: '司机电话' }
            ],
            advanceUrl: 'suDriver/searchByConditions',
            cbParams: [
                'name#driver', 'encuMobile#driverContactWay'
            ]
        },
        // {
        //     name: '承运商',
        //     value: 'carrierName',
        //     type: 'advance',
        //     advanceNotSearch: true,
        //     queryConditionRequired: true,
        //     border: true,
        //     multiple: true,
        //     maxSelect: 5,
        //     multipleTableColumn: {
        //         prop: 'supplierNameCn', 'value': '承运商名称'
        //     },
        //     advanceConfig: [
        //         { prop: 'supplierNameCn', 'value': '承运商名称' },
        //         { prop: 'supplierCode', 'value': '承运商编码' }
        //     ],
        //     tableConfig: [
        //         { prop: 'supplierNameCn', 'value': '承运商名称' },
        //         { prop: 'supplierCode', 'value': '承运商编码' }
        //     ],
        //     method: 'post',
        //     prefix: '/api-tms',
        //     advanceUrl: '/srm/supplier/search',
        //     cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode']
        // },
        {
            name: '签收类型',
            value: 'deliveredVerifyFlagList',
            type: 'select',
            multiple: true, // 多选
            filterable: true,
            optionNum: 'DELIVERED_VERIFY_FLAG',
            options: []
        },
        {
            name: '订单类型',
            value: 'orderTypeList',
            optionNum: 'ORDER_TYPE',
            filterable: true,
            multiple: true,
            type: 'select',
            options: []
        },
        {
            name: '转单类型',
            value: 'transferTypeList',
            optionNum: 'TRANSFER_TYPE_TMS',
            filterable: true,
            multiple: true,
            type: 'select',
            options: []
        },
        {
            name: '客户',
            value: 'customerName',
            type: 'advance',
            unfold: true,
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'ebcuNameCn', 'value': '客户名称'
            },
            advanceConfig: [
                { prop: 'ebcuNameCn', value: '客户名称' },
                { prop: 'pmCode', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'pmCode', value: '客户编码' },
                { prop: 'ebcuNameCn', value: '客户名称' }
            ],
            advanceUrl: '/ebCustomer/searchByEbCustomer',
            cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
            advanceCode: 'advanceCode'
        },
        {
            name: '来源系统',
            value: 'sourceSystemList',
            optionNum: 'SOURCE_SYSTEM',
            filterable: true,
            multiple: true,
            type: 'select',
            options: []
        },
        {
            name: '服务平台',
            advanceLabel: '服务平台',
            value: 'siteName',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            multipleTableColumn: {
                prop: 'escoCompanyNameCn', 'value': '服务平台名称'
            },
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/user/auth/data/site/query',
            type: 'advance',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
        },
        {
            name: '原承运商',
            value: 'planCarrierName',
            type: 'advance',
            advanceNotSearch: true,
            queryConditionRequired: true,
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'supplierNameCn', 'value': '承运商名称'
            },
            advanceConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' }
            ],
            tableConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' },
                { prop: 'transNameListStr', value: '采购渠道' }
            ],
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/srm/supplier/search',
            cbParams: ['supplierNameCn#planCarrierName', 'supplierCode#planCarrierCode']
        },
        {
            name: '线路名称',
            value: 'lineName',
            type: 'advance',
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'lineMergeName', value: '线路名称'
            },
            advanceConfig: [
                { prop: 'lineMergeName', value: '线路名称' },
                { prop: 'lineMergeId', value: '线路编码' }
            ],
            tableConfig: [
                { prop: 'lineMergeName', value: '线路名称' },
                { prop: 'lineMergeId', value: '线路编码' }
            ],
            method: 'post',
            paramType: true,
            prefix: '/api-opms/',
            advanceUrl: `opms/searchMergeLine`,
            cbParams: ['lineMergeName#lineName', 'lineMergeId#lineCode']
        },
        {
            name: '线路名称(旧)',
            value: 'lineNameV1',
            type: 'advance',
            multiple: true,
            multipleTableColumn: {
                prop: 'lineName', value: '线路名称'
            },
            advanceConfig: [
                { prop: 'all', value: '全部' },
                { prop: 'lineCode', value: '线路编码' },
                { prop: 'lineName', value: '线路名称' }
            ],
            prefix: '/api-dc',
            advanceUrl: `/line/page`,
            cbParams: ['lineCode#lineCodeV1', 'lineName#lineNameV1'],
            tableConfig: [
                { prop: 'lineCode', value: '线路编码' },
                { prop: 'lineName', value: '线路名称' }
            ]
        },
        {
            name: '业务场景',
            value: 'businessCategoryList',
            optionNum: 'BUSINESS_CATEGORY',
            multiple: true, // 多选
            filterable: true,
            type: 'select',
            options: []
        },
        {
            name: '专业公司',
            value: 'professionalCompanyList',
            optionNum: 'SYS_PROFESSIONAL_COMPANY',
            filterable: true,
            multiple: true, // 多选
            type: 'select',
            options: []
        },
        {
            name: '是否提供装卸服务',
            value: 'handlingStatus',
            type: 'select',
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '是否继续分拨',
            value: 'continueDistribution',
            type: 'select',
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '是否供应商转快递',
            value: 'supplierKdFlag',
            type: 'select',
            optionNum: 'SUPPLIER_KD_FLAG',
            options: []
        },
        {
            name: '装卸供应商',
            value: 'handlingCarrierName',
            type: 'advance',
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'suppliersNameCn', value: '承运商名称'
            },
            advanceConfig: [
                { prop: 'suppliersNameCn', value: '承运商名称' },
                { prop: 'suppliersCode', value: '承运商编码' }
            ],
            tableConfig: [
                { prop: 'suppliersNameCn', value: '承运商名称' },
                { prop: 'suppliersCode', value: '承运商编码' }
            ],
            advanceUrl: 'ebSupplier/searchBySupplierCodeOrNameCn',
            cbParams: ['suppliersNameCn#handlingCarrierName', 'suppliersCode#handlingCarrierCode']
        },
        {
            name: '是否分拨订单',
            value: 'distributionFlag',
            optionNum: 'DISTRIBUTION_FLAG',
            type: 'select',
            filterable: true,
            options: []
        },
        {
            name: '服务产品编码',
            value: 'productCode',
            type: 'input'
        },
        {
            name: '服务产品名称',
            value: 'productName',
            type: 'input'
        },
        {
            name: '平台单号',
            value: 'platformOrderNo',
            type: 'input'
        },
        {
            name: '配送方式',
            value: 'deliveryTypeList',
            optionNum: 'DELIVERY_TYPE',
            type: 'select',
            filterable: true,
            multiple: true, // 多选
            options: []
        },
        {
            name: '高端服务',
            value: 'emergencyFlagList',
            type: 'select',
            multiple: true,
            filterable: true,
            optionNum: 'OTP_EMERGENCE_FLAG',
            options: []
        },
        {
            name: '收货地省',
            value: 'receiverProvinceName',
            type: 'advance',
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'ebplNameCn', value: '收货人地省名称'
            },
            advanceConfig: [
                { prop: 'ebplNameCn', value: '收货地省名称' },
                { prop: 'ebplCode', value: '收货地省编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', value: '收货地省名称' },
                { prop: 'ebplCode', value: '收货地省编码' }
            ],
            cbParams: ['ebplCode#receiverProvinceCode', 'ebplNameCn#receiverProvinceName'],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_PROVINCE&ebplParentPmCode=100000',
            advanceCode: 'receiverProvinceCode'
        },
        {
            name: '收货地市',
            value: 'receiverCityName',
            type: 'advance',
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'ebplNameCn', value: '收货人地省名称'
            },
            advanceConfig: [
                { prop: 'ebplNameCn', value: '收货地市名称' },
                { prop: 'ebplCode', value: '收货地市编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', value: '收货地省名称' },
                { prop: 'ebplCode', value: '收货地市编码' }
            ],
            cbParams: ['ebplCode#receiverCityCode', 'ebplNameCn#receiverCityName'],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
            advanceCode: 'receiverCityCode'
        },
        {
            name: '发运类型',
            value: 'shippingTypeList',
            optionNum: 'TMS_SHIPPING_TYPE',
            type: 'select',
            multiple: true,
            filterable: true,
            options: []
        },
        {
            name: 'VP客户标识',
            value: 'vipFlagList',
            optionNum: 'TMS_VIP_FLAG',
            type: 'select',
            multiple: true,
            filterable: true,
            options: []
        },
        {
            name: '标准收货人',
            value: 'standardReceiverName',
            type: 'advance',
            advanceConfig: [
                { prop: 'csName', value: '标准收货人名称' },
                { prop: 'csCode', value: '标准收货人编码' }
            ],
            tableConfig: [
                { prop: 'csName', value: '标准收货人名称' },
                { prop: 'csCode', value: '标准收货人编码' }
            ],
            prefix: '/api-dc',
            advanceUrl: '/standardConsigneeShipper?enableFlag=1',
            cbParams: ['csCode#standardReceiverCode', 'csName#standardReceiverName']
        },
        {
            name: '事业部',
            value: 'entityIdList',
            type: 'select',
            optionNum: 'OMS_PARAMS_ENTITY_ID',
            options: [],
            multiple: true,
            filterable: true
        },
        {
            name: '出库时间',
            value: 'loadDate',
            startTime: 'loadDateStart',
            endTime: 'loadDateEnd',
            startPlaceholder: '出库开始日期',
            endPlaceholder: '出库结束日期',
            type: 'time'
        },
        {
            name: '是否下发承运商',
            value: 'carrierVisibleFlag',
            type: 'select',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ]
        },
        {
            name: '发货城市',
            value: 'senderAddress',
            type: 'addressCascader',
            minLayers: 3,
            span: 4
        },
        {
            name: '场景标识',
            value: 'loanScenarioCodeList',
            type: 'select',
            multiple: true,
            filterable: true,
            maxSelect: 10,
            optionNum: 'CUSTOMER_SCENCE',
            options: []
        },
        {
            name: '2C批量直配',
            value: 'b2cZpFlagList',
            type: 'select',
            multiple: true, // 多选
            options: [
                { label: '是', value: '1' },
                { label: '否', value: '0' }
            ]
        },
        {
            name: '计费业务类型',
            value: 'businessType',
            type: 'select',
            optionNum: 'BUSINESS_TYPE',
            options: []
        },
        {
            name: '收入计费前置',
            value: 'billingIncomeAdvanceFlag',
            type: 'select',
            optionNum: 'BILLING_ADVANCE_FLAG',
            options: []
        },
        {
            name: '成本计费前置',
            value: 'billingCostAdvanceFlag',
            type: 'select',
            optionNum: 'BILLING_ADVANCE_FLAG',
            options: []
        },
        {
            name: '多次打印',
            value: 'isPrintTimes',
            type: 'select',
            optionNum: '',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ]
        },
        {
            name: '订单服务类型',
            value: 'serviceTypeList',
            type: 'select',
            optionNum: 'ORDER_SERVICE_TYPE',
            options: [],
            multiple: true
        },
        {
            name: '要求发车时间',
            value: 'requireDepartTime',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'time'
        },
        {
            name: '要求到车时间',
            value: 'requireCarArriveTime',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'time'
        },
        {
            name: '要求抵达时间',
            value: 'requireArriveTime',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'time'
        },
        {
            name: '要求签收时间',
            value: 'requestSignDate',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'time'
        }
    ]
};
